module.exports = __webpack_public_path__ + "1_0_65/img/env-2.d855b519.png";